import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../shared/adapters/datepicker-adapter';
import { ccPaymentReportModel } from './shared/models/ccPaymentReportModel';
import { CcPaymentReportService } from './shared/services/cc-payment-report.service';

@Component({
  selector: 'app-cc-payment-report',
  templateUrl: './cc-payment-report.component.html',
  styleUrls: ['./cc-payment-report.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class CcPaymentReportComponent implements OnInit {

  ccPaymentReportSearchCriteria: ccPaymentReportModel;
  page: number;
  customer: any;
  FranchiseList: any;
  Value: any;
  customerSearch: any;
  DateFrom: NgbDateStruct;
  DateTo: NgbDateStruct;
  paraNoRec: boolean = true;
  maxDate: NgbDateStruct;


  constructor(private _modalSvc: NgbModal, private ccPaymentReportService: CcPaymentReportService) { }

  ngOnInit() {
    this.resetForm();
    const current = new Date();
    this.maxDate = { year: current.getFullYear(), month: current.getMonth() + 1, day: current.getDate() };
    this.ccPaymentReportService.getCcPaymentReportFranchiseList().subscribe(response => {
      if (response) {
        this.customer = response;
        console.log(response);
      }

    });
  }

  resetForm() {
    let from = new Date();
    let to = new Date();
    // from.setDate(from.getDate() - 7);
    this.DateFrom = { year: from.getFullYear(), month: from.getMonth() + 1, day: from.getDate() }
    this.DateTo = { year: to.getFullYear(), month: to.getMonth() + 1, day: to.getDate() },
      this.ccPaymentReportSearchCriteria = {
        DateFrom: (from.getMonth() + 1) + '/' + from.getDate() + '/' + from.getFullYear(),
        DateTo: (to.getMonth() + 1) + '/' + to.getDate() + '/' + to.getFullYear(),
        PageNo: 1,
        PageSize: 10,
        Code: null,
        FranchiseId: '',
        InvoiceTypeId: 0,
      };
    this.page = this.ccPaymentReportSearchCriteria.PageNo;
  }

  cancelSearch() {
    this.ngOnInit();
    this.customerSearch = null;
    this.paraNoRec = true;
  }

  getSearch(PageNo: number) {
    this.ccPaymentReportSearchCriteria.PageNo = PageNo;
    this.ccPaymentReportSearchCriteria.DateFrom = this.DateFrom.month + '/' + this.DateFrom.day + '/' + this.DateFrom.year;
    this.ccPaymentReportSearchCriteria.DateTo = this.DateTo.month + '/' + this.DateTo.day + '/' + this.DateTo.year;
    this.ccPaymentReportService.getCcPaymentReport(this.ccPaymentReportSearchCriteria).subscribe(response => {
      if (response) {
        this.customerSearch = response;
        if (response?.CustomerWiseInvoicesSummaryList?.length > 0) {
          this.paraNoRec = false;
        }
        console.log(response);
      }
    });
  }

}